import { ChangeEvent } from "react";
import { useResumeData } from "../hooks/useResumeData";

const ImportResumeJSON: React.FC = () => {
  const [, setResumeData] = useResumeData();

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = (e: ProgressEvent<FileReader>) => {
        try {
          const content = JSON.parse(e.target!.result as string);
          setResumeData(content);
          window.location.reload();
        } catch (error) {
          console.error("Error parsing JSON file: ", error);
        }
      };

      reader.readAsText(file);
    }
  };

  return (
    <div>
      <label
        htmlFor="file-input"
        className={`flex items-center gap-3 text-sm font-semibold rounded-lg bg-[#2a3035] text-dark-fg cursor-pointer mb-2 p-4 text-center`}
        title="Import Resume JSON"
      >
        <i className="fa fa-upload" />
        <div className="text-left">Import Resume JSON</div>
      </label>
      <input
        type="file"
        id="file-input"
        style={{ display: "none" }}
        onChange={handleFileUpload}
      />
    </div>
  );
};

export default ImportResumeJSON;
